import { Routes, Route } from "react-router-dom";
import { sadminnavigationLinks } from "../data/navData";
import DashboardLayout from "../layout/DashboardLayout/DashboardLayout";
import AdminHome from "../pages/adminPages/AdminHome";
import AdminAssets from "../pages/adminPages/AdminAssets";
import AdminRepair from "../pages/adminPages/AdminRepair";
import AdminMaintenance from "../pages/adminPages/AdminMaintenance";
import SAdminRReport from "../pages/superAdminPages/SAdminRRport";
import SAdminMReport from "../pages/superAdminPages/SAdminMReport";
import Account from "../components/Account/Account";
import SAdminAcademies from "../pages/superAdminPages/SAdminAcademies";
import SAdminUser from "../pages/superAdminPages/SAdminUser";
import FeedbackReport from "../pages/FeedbackReport";
import VendorManagement from "../pages/adminPages/Vendors";
import ProtectedRoute from "./ProtectedRoute";
import SuperAdminAttendance from "../pages/superAdminPages/SuperAdminAttendance";
import SuperAdminAttendanceRecords from "../pages/superAdminPages/SuperAdminAttendanceRecords";
import SuperAdminEmployeeLeaveRequests from "../pages/superAdminPages/SuperAdminEmployeeLeaveRequests";
import SuperAdminEmployeeAttendance from "../pages/superAdminPages/SuperAdminEmployeeAttendance";
import AttendanceRecordDetail from "../pages/attendance/AttendanceRecordDetail";
import UserDetails from "../pages/UserDetails";
const SuperAdminRoutes = () => {
  return (
    <DashboardLayout
      navigationLinks={sadminnavigationLinks}
      roleBasePath="superadmin"
      useApiLogout={false}
    >
      <Routes>
        <Route
          path=""
          element={
            <ProtectedRoute element={<AdminHome />} requiredRole="SuperAdmin" />
          }
        />
        <Route
          path="attendance/record/record/:id"
          element={
            <ProtectedRoute
              element={<AttendanceRecordDetail />}
              requiredRole="SuperAdmin"
            />
          }
        />
        <Route
          path="academies"
          element={
            <ProtectedRoute
              element={<SAdminAcademies />}
              requiredRole="SuperAdmin"
            />
          }
        />
        <Route
          path="users"
          element={
            <ProtectedRoute
              element={<SAdminUser />}
              requiredRole="SuperAdmin"
            />
          }
        />
        <Route
          path="users/:email"
          element={
            <ProtectedRoute
              element={<UserDetails />}
              requiredRole="SuperAdmin"
            />
          }
        />
        <Route
          path="assets"
          element={
            <ProtectedRoute
              element={<AdminAssets />}
              requiredRole="SuperAdmin"
            />
          }
        />
        <Route
          path="repair-maintenance"
          element={
            <ProtectedRoute
              element={<AdminRepair />}
              requiredRole="SuperAdmin"
            />
          }
        />
        <Route
          path="preventive-maintenance"
          element={
            <ProtectedRoute
              element={<AdminMaintenance />}
              requiredRole="SuperAdmin"
            />
          }
        />
        <Route
          path="repair-report"
          element={
            <ProtectedRoute
              element={<SAdminRReport />}
              requiredRole="SuperAdmin"
            />
          }
        />
        <Route
          path="maintenance-report"
          element={
            <ProtectedRoute
              element={<SAdminMReport />}
              requiredRole="SuperAdmin"
            />
          }
        />
        <Route
          path="vendor"
          element={
            <ProtectedRoute
              element={<VendorManagement />}
              requiredRole="SuperAdmin"
            />
          }
        />
        <Route
          path="account"
          element={
            <ProtectedRoute element={<Account />} requiredRole="SuperAdmin" />
          }
        />
        <Route
          path="feedback"
          element={
            <ProtectedRoute
              element={<FeedbackReport />}
              requiredRole="SuperAdmin"
            />
          }
        />
        <Route
          path="attendance"
          element={
            <ProtectedRoute
              element={<SuperAdminAttendance />}
              requiredRole="SuperAdmin"
            />
          }
        />
        <Route
          path="attendance/record"
          element={
            <ProtectedRoute
              element={<SuperAdminAttendanceRecords />}
              requiredRole="SuperAdmin"
            />
          }
        />
        <Route
          path="attendance/record/:id"
          element={
            <ProtectedRoute
              element={<AttendanceRecordDetail />}
              requiredRole="SuperAdmin"
            />
          }
        />
        <Route
          path="attendance/employee-leave-requests"
          element={
            <ProtectedRoute
              element={<SuperAdminEmployeeLeaveRequests />}
              requiredRole="SuperAdmin"
            />
          }
        />
        <Route
          path="attendance/employee-attendance"
          element={
            <ProtectedRoute
              element={<SuperAdminEmployeeAttendance />}
              requiredRole="SuperAdmin"
            />
          }
        />
        <Route path="*" element={<h1>404 - Page Not Found</h1>} />
      </Routes>
    </DashboardLayout>
  );
};

export default SuperAdminRoutes;
